import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { MarkerFragment } from '../Map/FacilityPopupContent';
import MapEditor from '../MapEditor';

const propTypes = {
  facilities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      location: PropTypes.shape({
        coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
      }).isRequired,
    }),
  ).isRequired,
  primaryFacilityId: PropTypes.string,
  multiFacility: PropTypes.bool,
};

const defaultProps = {
  primaryFacilityId: undefined,
  multiFacility: false,
};

const FacilitiesMapEditor = ({ facilities, primaryFacilityId, ...rest }) => (
  <MapEditor
    {...rest}
    facilities={facilities.map(x => ({
      ...x,
      latitude: x.location.coordinates[1],
      longitude: x.location.coordinates[0],
      isPrimary: x.id === primaryFacilityId,
    }))}
  />
);

FacilitiesMapEditor.propTypes = propTypes;
FacilitiesMapEditor.defaultProps = defaultProps;

FacilitiesMapEditor.fragments = {
  facility: gql`
    fragment FacilitiesMapEditorFacility on Facility {
      id
      location {
        coordinates
      }
      ...FacilitiesMapMarkerFacility
    }

    ${MarkerFragment}
  `,
};

export default FacilitiesMapEditor;
